import { useEffect, useState } from "react";
import FileUploader from "../../../components/FileUploader";

const WidowPostDocProofs = ({translation, docData, setCurrentStep, postSlug, isUpdate}) => {


  const [oldElectricBill, setOldElectricBill] = useState(null);
  const [oldCnicFile, setOldCnicFile] = useState(null);
  const [oldSpouseDeathCertificate, setOldSpouseDeathCertificate] = useState(null);
  const [oldMarriageCertificate, setOldMarriageCertificate] = useState(null);

  const [uploadedMarriageCertificate, setUploadedMarriageCertificate] = useState(false);
  const [uploadedElectricBill, setUploadedElectricBill] = useState(false);
  const [uploadedSpouseDeathCertificate, setUploadedSpouseDeathCertificate] = useState(false);

  useEffect(()=>{
    if (docData){
      setOldCnicFile(docData?.documents?.cnic_front)
      setOldElectricBill(docData?.documents?.electric_bill)
      setOldSpouseDeathCertificate(docData?.documents?.spouse_death_certificate)
      setOldMarriageCertificate(docData?.documents?.marriage_certificate)

      setUploadedMarriageCertificate(true)
      setUploadedElectricBill(true)
      setUploadedSpouseDeathCertificate(true)
    }
  }, [docData])
  
  return (
    <>
      <h2 className="mb-6 text-2xl dark:text-white">{translation.other.heading5}</h2>
      <form onSubmit={()=>{setCurrentStep("submit_view_post")}} className="pt-3 pb-6 space-y-4">
        {/* Electric Bill Upload */}
        <div className="flex flex-col space-y-1">
          <label htmlFor="electric_bill" className="block font-semibold mb-1 dark:text-white">
            {translation.other.elect_bill_name}
          </label>

          <FileUploader
            fileNameInDB={'electric_bill'}
            key="electric_file_uploader"
            allowedTypes={['jpeg','jpg', 'pdf', 'png', 'bmp', 'webp', 'heic', 'heif']}
            onSuccess={(filePath)=>{
              setUploadedElectricBill(true)
              setOldElectricBill(filePath)
            }}
            generateUrlEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/generate-presigned-url/`}
            updateBackendEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/upload-post-docs/`}
            additionalFormData={{'slug': postSlug}}
            maxSizeMB={100}
             
            awsUploadDestination={'posts/username/docs'}
            description={translation.other.electric_bill_description}
            showPreview={oldElectricBill ? `${process.env.REACT_APP_CDN_URL}/${oldElectricBill}` : null} 

          />
        </div>

        
        {/* CNIC Upload */}
        <div className="flex flex-col space-y-1">
          <label htmlFor="seeker_cnic" className="block font-semibold mb-2 dark:text-white">
            {translation.other.seeker_cnic}
          </label>
          <FileUploader
            fileNameInDB={'cnic_front'}
            key="cnic_file_uploader"
            allowedTypes={['jpeg', 'pdf', 'jpg','png', 'bmp', 'webp', 'heic', 'heif']}
            onSuccess={(filePath)=>{
              setOldCnicFile(filePath)
            }}
            generateUrlEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/generate-presigned-url/`}
            updateBackendEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/upload-post-docs/`}
            additionalFormData={{'slug': postSlug}}
            maxSizeMB={100}
             
            awsUploadDestination={'posts/username/docs'}
            description={translation.other.cnic_front_description}
            showPreview={oldCnicFile ? `${process.env.REACT_APP_CDN_URL}/${oldCnicFile}` : null} 

          />
          
        </div>
        

        <div className="flex flex-col space-y-1">
          <label htmlFor="spouse_death_certificate" className="block font-semibold mb-2 dark:text-white">
            {translation.other.husband_death_certificate}
          </label>

          <FileUploader
            fileNameInDB={'spouse_death_certificate'}
            key="spouse_death_certificate_file_uploader"
            allowedTypes={['jpeg', 'pdf', 'jpg', 'png', 'bmp', 'webp', 'heic', 'heif']}
            onSuccess={(filePath)=>{
              setUploadedSpouseDeathCertificate(true)
              setOldSpouseDeathCertificate(filePath)
            }}
            generateUrlEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/generate-presigned-url/`}
            updateBackendEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/upload-post-docs/`}
            additionalFormData={{'slug': postSlug}}
            maxSizeMB={100}
             
            awsUploadDestination={'posts/username/docs'}
            description={translation.other.husband_death_certificate_description}
            showPreview={oldSpouseDeathCertificate ? `${process.env.REACT_APP_CDN_URL}/${oldSpouseDeathCertificate}` : null} 
            
          />
        </div>

        <div className="flex flex-col space-y-1">
          <label htmlFor="marriage_certificate" className="block font-semibold mb-2 dark:text-white">
            {translation.other.marriage_certificate}
          </label>

          <FileUploader
            fileNameInDB={'marriage_certificate'}
            key="marriage_certificate_file_uploader"
            allowedTypes={['jpeg', 'pdf', 'jpg','png', 'bmp', 'webp', 'heic', 'heif']}
            onSuccess={(filePath)=>{
              setUploadedMarriageCertificate(true)
              setOldMarriageCertificate(filePath)
            }}
            generateUrlEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/generate-presigned-url/`}
            updateBackendEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/upload-post-docs/`}
            additionalFormData={{'slug': postSlug}}
            maxSizeMB={100}
             
            awsUploadDestination={'posts/username/docs'}
            description={translation.other.marriage_certificate_description}
            showPreview={oldMarriageCertificate ? `${process.env.REACT_APP_CDN_URL}/${oldMarriageCertificate}` : null} 

          />
        </div>

        
        
        
        {/* Submit Button */}
        <div className="flex space-x-3">
            {isUpdate && 
              <button
                onClick={()=>{
                  setCurrentStep("attach_video_proofs");
                }}
                className="w-full rounded-md bg-blue-500 text-white font-extrabold px-4 py-2 hover:bg-blue-600 "
              >
                {translation.back}
              </button> 
            }

            <button
              type="submit"
              className="w-full rounded-md bg-blue-500 text-white font-extrabold px-4 py-2 hover:bg-blue-600 disabled:bg-gray-400 disabled:text-gray-200 disabled:cursor-not-allowed"
              disabled={ !uploadedElectricBill || !uploadedMarriageCertificate || !uploadedSpouseDeathCertificate}
            >
              {translation.next}
            </button>
        </div>
      </form>
    </>
  )
}

export default WidowPostDocProofs;